export default [
  {
    key: 'increasement',
    sortable: true,
    sortField: 'createdAt',
  label: 'label.no',
    thClass: 'w-50px text-center',
    tdClass: 'text-center',
  },
  {
    key: 'name',
    sortable: true,
    sortField: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'countMerchant',
    label: 'field.assign_to',
  },
  {
    key: 'countUser',
    label: 'field.numberEmployee',
  },
  {
    key: 'createdAt',
    sortable: true,
    sortField: 'createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
];
